<template>
  <section :class="cssClass">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-7 col-lg-6 rc-col-text rc-col-max-width rc-col-form">
          <div>
            <h2 v-html="$t('auth.widget_verify.school.title')"></h2>
            <RcSubscriberVerify :labelCols="4" />
          </div>
        </div>
        <div class="col-md-5 col-lg-6 rc-col-text rc-col-max-width">
          <div>
            <h2 v-html="$t('auth.widget_verify.library.title')"></h2>
            <p
              class="rc-intro"
              v-html="$t('auth.widget_verify.library.intro')"
            ></p>
            <rc-btn
              size="md"
              variant="dark"
              class="rc-btn-access-point mt-4"
              data-bs-toggle="modal"
              data-bs-target="#findAccessModal"
            >
              <RcIcon name="geoFill" scale="1.5"></RcIcon>

              {{ $t("auth.access_points.find") }}</rc-btn
            >
            <RcFindAccessModal />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { navMixin } from "#/routes/mixins";
import RcSubscriberVerify from "#/pages/subscribers/components/SubscriberVerify.vue";
import RcFindAccessModal from "#/pages/onboard/components/FindAccessModal.vue";
import RcIcon from "@/libvue/components/icons/Base.vue";
export default {
  name: "RcVerifySubscription",
  props: {
    cssClass: {
      type: String,
      default: ""
    }
  },
  components: {
    RcSubscriberVerify,
    RcFindAccessModal,
    RcIcon
  },
  mixins: [navMixin]
};
</script>

<style scoped></style>
